import { render } from "./PaymentMethodInstance.vue?vue&type=template&id=5fe9c79c&scoped=true"
import script from "./PaymentMethodInstance.vue?vue&type=script&lang=js"
export * from "./PaymentMethodInstance.vue?vue&type=script&lang=js"

import "./PaymentMethodInstance.vue?vue&type=style&index=0&id=5fe9c79c&scoped=true&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe9c79c"]])

export default __exports__